import React, { Component } from "react";
import "./Filter.scss";

export default class Filter extends Component {
  render() {
    return (
      <div className="filter">
        <div className="filter__result">{this.props.count} Products</div>
        <div className="filter__sort">
          <p>Order</p>
          <select
            value={this.props.sort}
            onChange={this.props.sortProducts}
            className="filter__select"
          >
            <option value="">Latest</option>
            <option value="lowest">Lowest</option>
            <option value="highest">Highest</option>
          </select>
        </div>
        <div className="filter__option">
          <p>Filter</p>
          <select
            value={this.props.type}
            onChange={this.props.filterProducts}
            className="filter__select"
          >
            <option value="">All</option>
            <option value="Cookie">Cookies</option>
            <option value="Cupcake">Cupcakes</option>
            <option value="Confection">Confections</option>
          </select>
        </div>
      </div>
    );
  }
}
